import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  getEquipmentLog,
} from '../../../store/actions';
import Log from './log';

const mapStateToProps = ({ vendorEquipmenReducer }) => ({
  allEquipmentLog: vendorEquipmenReducer.allEquipmentLog,
});

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    getEquipmentLog,
  },
  dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(Log);
